import { getCurrentCompanyId, getToken } from '../../Lib/Utils';

const AuthToken = async () => {
    const tokenToUse = await getToken();

    return `Bearer ${tokenToUse}`;
};

const requestMiddleware = {
    name: 'requestMiddleware',
    req: async (payload) => {
        payload.req.headers['Authorization'] = await AuthToken();
        payload.req.headers['X-Paytron-Account'] = getCurrentCompanyId();
        if (['GET', 'DELETE'].includes(payload.req.method)) payload.req.data = {};
        return payload;
    },
};

const urlMiddleware = {
    name: 'urlMiddleware',
    req: (payload) => {
        payload.req = {
            ...payload.req,
            url: payload.req.url.replace(`com/${payload.req.model}s`, 'com'),
        };
        return payload;
    },
};

const subscriptionsMiddleware = {
    name: 'urlMiddleware',
    req: (payload) => {
        payload.req = {
            ...payload.req,
            url: !['managed'].includes(payload.req.model)
                ? payload.req.url.replace(`com/${payload.req.model}s`, 'com')
                : payload.req.url.replace(`com/${payload.req.model}s`, `com/${payload.req.model}`),
        };
        return payload;
    },
};

const invoiceRequestMiddleware = {
    name: 'invoiceRequestMiddleware',
    req: async (payload) => {
        payload.req.headers['Authorization'] = await AuthToken();
        payload.req.headers['X-Paytron-Account'] = payload.req.params.companyId || getCurrentCompanyId();
        payload.req.params = payload.req.params.companyId ? {} : payload.req.params;
        if (['GET', 'DELETE'].includes(payload.req.method)) payload.req.data = {};
        return payload;
    },
};

const invoiceMiddleware = {
    name: 'invoiceMiddleware',
    res: (payload) => {
        const invoices = payload.data.filter((i) => i.type === 'invoice');
        const lines = payload.data.filter((l) => l.type === 'line');

        invoices.map((i) => {
            i.lines = i.lines.map((line) => {
                return {
                    ...line,
                    ...lines.find((l) => l.id === line.id),
                };
            });
            return i;
        });

        return {
            ...payload,
            data: invoices,
        };
    },
};

export { requestMiddleware, urlMiddleware, invoiceRequestMiddleware, invoiceMiddleware, subscriptionsMiddleware };
